export enum CardVariation {
  'SquareV1' = 'square-v1',
  'SquareV2' = 'square-v2',
  'SquareV3' = 'square-v3',
  'Wide' = 'tile-wide',
}

export interface MerchandisingCardTileProps extends Partial<ITargetContent> {
  styleclass: string;
  componentId: string;
  isAuthor: boolean;
  merchandisingCategory: string;
  displayEvergreenContent: boolean;
  promotionalTag: string;
  impressionTrack: string;
  impressionCount: string;
  tileSquareVariation: CardVariation;
  eyebrowText: string;
  fileReferenceImage: string;
  headerMedium: string;
  destinationUrl1: string;
  openInNewTab: boolean;
  mboxParameter: string;
  imageWide: Image;
  image: Image;
  wcmMode: string;
  path: string;
  trackingProperties: TrackingProperties;
  ':type': string;
  reRenderContainer?: CallableFunction;
  updateCarousel?: CallableFunction;
  ariaLabel?: string;
}

interface TrackingProperties {
  location: string;
  trackingTag: string;
  trackingContentPosition: string;
  trackingDescription: string;
  trackingOfferType: string;
  merchandisingCategory: string;
  atCCeVar48: string;
  clickTrack: boolean;
  impressionTrack: boolean;
  impressionCount: boolean;
  enableScrollingBehavior: boolean;
  leftArrowDesc: string;
  cardLocation: string;
  rightArrowDesc: string;
  description: string;
}

interface Image {
  damPath: string;
  assetPath: string;
  altText: string;
  dynamic: boolean;
  enableSmartCrop: boolean;
  renditions: Rendition[];
}

interface Rendition {
  renditionPath: string;
  damPath: string;
  mediaValue: string;
  mediaQuery: string;
  width: number;
  height: number;
  smartCropType: string | null;
  dynamic: boolean;
}

interface ITargetContent {
  metaData: IMetaData;
  mboxName: string;
  logo: ILogo;
  isTargetContentLoaded: boolean;
  isTargetContentError: boolean;
}

export interface ILogo {
  title: string;
  altText?: string;
  caption: string;
  marketingCaption: string;
  alternateDescription: string;
  isPrimaryArchitectural: boolean;
  isSecondaryArchitectural: boolean;
  isPrimaryServices: boolean;
  isSecondaryServices: boolean;
  is360Photo: boolean;
  isPrimary: boolean;
  imageUrls: ImageUrls;
  imageSrc: string;
  defaultImage: boolean;
  roomPoolCodes: unknown[];
  roomTypeCodes: unknown[];
  __typename: string;
}

interface ImageUrls {
  panoramicHorizontal: string;
  panoramicVertical: string;
  wideHorizontal: string;
  wideVertical: string;
  featureHorizontal: string;
  featureVertical: string;
  classicHorizontal: string;
  classicVertical: string;
  square: string;
  deviceSmall: string;
  flex: string;
  __typename: string;
}

interface IMetaData {
  campaignId: string;
  cell: string;
  countryCode: string;
  endDate: string;
  guidSecondary: null;
  issuerCode: string;
  loyaltyBar: boolean;
  mathOffer: boolean;
  merTag: null;
  offerCode: string;
  optionalFields: null;
  prequal: boolean;
  rpcCode: string;
  spid: string;
  startDate: string;
  theme: string;
  title: string;
  type: string;
}
